// config
import { config } from '@shakkerai/config';

// ajax
import { ajax } from '@shakkerai/util-ajax';
import { get as ajaxGet, post as ajaxPost } from 'qiao-ajax';

// cookie
import { getUsertokenFromCookie, getCookieWebid } from '@shakkerai/util-cookie';
import { clearUserinfo } from '@shakkerai/business-userinfo';

// default headers
function defaultHeaders() {
  return config && config.language
    ? {
        'accept-language': config.language,
      }
    : {};
}

/**
 * get
 * @param {*} url
 * @param {*} data
 * @param {*} headers
 * @returns
 */
export const get = async (url, data, headers) => {
  // headers
  const finalHeaders = Object.assign(headers || {}, defaultHeaders());

  // json
  const json = await ajax(ajaxGet, url, data, finalHeaders);
  return checkAuth(json);
};

/**
 * getWithToken
 * @param {*} url
 * @param {*} data
 * @param {*} headers
 * @returns
 */
export const getWithToken = async (url, data, headers) => {
  // headers
  const finalHeaders = Object.assign(headers || {}, defaultHeaders());
  finalHeaders.token = getUsertokenFromCookie();

  // json
  const json = await ajax(ajaxGet, url, data, finalHeaders);
  return checkAuth(json);
};

/**
 * post
 * @param {*} url
 * @param {*} data
 * @param {*} headers
 * @returns
 */
export const post = async (url, data, headers) => {
  // headers
  const finalHeaders = Object.assign(headers || {}, defaultHeaders());

  // json
  const json = await ajax(ajaxPost, url, data, finalHeaders);
  return checkAuth(json);
};

/**
 * postWithToken
 * @param {*} url
 * @param {*} data
 * @param {*} headers
 * @returns
 */
export const postWithToken = async (url, data = {}, headers = {}, config = { timeout: 60000 }) => {
  // headers
  const finalHeaders = Object.assign(headers || {}, defaultHeaders());
  finalHeaders.token = getUsertokenFromCookie();
  const cid = getCookieWebid();

  const json = await ajax(
    (url, options) => ajaxPost(url, { ...options, ...config }),
    url,
    {
      ...data,
      cid,
    },
    finalHeaders,
  );
  return checkAuth(json);
};

// check auth
function checkAuth(json) {
  // ok
  if (json.code !== 401) return json;

  // clear
  clearUserinfo();

  // redirect
  const location = window.location;
  if (config && config.env === 'aws') {
    if (!['/', '/pro', '/aigenerator'].includes(location.pathname) || location.hash) {
      // window.location.href = '/';
      window.location.reload();
    }
  } else {
    if (!['/', '/pro'].includes(location.pathname) || location.hash) {
      window.location.href = '/';
    }
  }
  return json;
}
